import React from 'react';

import './ContentWrap.scss';

const ContentWrap: React.FC = ({ children }) => {
  return <div className="content-wrap">{children}</div>;
};

export default ContentWrap;
